// extracted by mini-css-extract-plugin
export default {"modal-competition":"ModalCompetition_modal-competition__Riem6","content":"ModalCompetition_content__3SkeJ"};